var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8861 39.2505C18.3992 39.0448 9.03533 38.6052 7.37313 38.4953C5.30737 38.3595 3.51732 34.234 3.40144 29.623C3.18568 20.9763 3.01786 12.2338 7.39311 8.33405C12.082 4.15259 16.5192 3.60917 24.4466 3.6771C31.1773 3.73304 38.1917 4.46625 42.4151 9.58669C45.9233 13.8381 45.6856 23.2039 45.1861 28.4063C44.5888 34.6235 43.3801 38.9988 41.1825 39.1646C38.9849 39.3284 32.6737 39.4983 24.8861 39.2505Z",
    stroke: "black",
    strokeWidth: 0.59935,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4463 3.75901C28.4463 3.75901 29.8987 2.76009 30.1145 2.09681C30.3302 1.43353 30.2284 1 30.2284 1",
    stroke: "black",
    strokeWidth: 0.59935,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8184 3.64669C29.8184 3.64669 30.2998 3.04135 31.2188 2.46198C31.6943 2.1623 32.2677 2.06641 32.2677 2.06641",
    stroke: "black",
    strokeWidth: 0.59935,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1182 13.1779C31.9909 11.9119 40.3069 9.98932 48.9995 13.8631",
    stroke: "black",
    strokeWidth: 0.998917,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5752 11.1807C1.5752 11.1807 15.1843 8.09222 20.2038 13.3613",
    stroke: "black",
    strokeWidth: 0.998917,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2709 13.8398L47.7655 22.4345L29.0078 21.5055",
    stroke: "black",
    strokeWidth: 0.59935,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.389 20.9771L1 19.8363L1.57538 11.1797",
    stroke: "black",
    strokeWidth: 0.59935,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8476 16.8759C25.0864 16.732 23.8218 16.6801 22.7989 16.9877C21.9837 17.2315 21.4883 17.701 21.4883 17.701C22.703 22.248 24.6988 23.2649 24.6988 23.2649C24.6988 23.2649 28.1191 20.9794 27.8993 18.1405",
    stroke: "black",
    strokeWidth: 0.59935,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2586 17.2325C39.2586 18.4029 38.0578 18.9322 36.5766 18.9322C35.0953 18.9322 33.8945 18.4029 33.8945 17.2325C33.8945 16.0621 35.0953 15.1133 36.5766 15.1133C38.0578 15.1133 39.2586 16.0621 39.2586 17.2325Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7713 15.6817C13.7713 16.8521 12.5705 17.3814 11.0893 17.3814C9.60802 17.3814 8.40723 16.8521 8.40723 15.6817C8.40723 14.5113 9.60802 13.5625 11.0893 13.5625C12.5705 13.5625 13.7713 14.5113 13.7713 15.6817Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMid);
export default __webpack_public_path__ + "static/media/mid.888dd47e8983f436c958ff027090784d.svg";
export { ForwardRef as ReactComponent };